import axios from 'axios';
import { kvSet, kvGet, kvDel } from '@/lib/offlineDb';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Decode JWT payload without verifying signature (we only inspect `exp` here).
function decodeJwt(token) {
  try {
    const part = token.split('.')[1];
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export const setAuthHeader = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem('pm_token', token);
    // Mirror into IndexedDB so we can validate offline boots even when
    // localStorage gets wiped (Safari aggressive eviction after 7 days).
    try { kvSet('pm_token', token); } catch {}
    const payload = decodeJwt(token);
    if (payload?.exp) {
      try { kvSet('pm_token_exp', payload.exp); } catch {}
    }
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem('pm_token');
    try { kvDel('pm_token'); kvDel('pm_token_exp'); } catch {}
  }
};

const stored = typeof window !== 'undefined' ? localStorage.getItem('pm_token') : null;
if (stored) {
  api.defaults.headers.common.Authorization = `Bearer ${stored}`;
}

export const getToken = () => (typeof window !== 'undefined' ? localStorage.getItem('pm_token') : null);

/** Read the cached JWT from IndexedDB if localStorage was evicted. */
export async function readCachedToken() {
  const ls = typeof window !== 'undefined' ? localStorage.getItem('pm_token') : null;
  if (ls) return ls;
  try { return await kvGet('pm_token'); } catch { return null; }
}

/** Is the cached JWT still within its `exp`? Used to allow offline login. */
export async function isCachedTokenValid() {
  const token = await readCachedToken();
  if (!token) return false;
  const payload = decodeJwt(token);
  if (!payload?.exp) return false;
  return payload.exp * 1000 > Date.now();
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err.message || 'Error desconocido';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(d => d?.msg || JSON.stringify(d)).join(' ');
  return String(detail);
}
